import { Box, Switch, Tooltip, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface CompactToggleProps {
    labelId: string;
    tooltipId: string;
    value: boolean;
    onChange: (val: boolean) => void;
}

export default function CompactToggle({
    labelId,
    tooltipId,
    value,
    onChange,
}: CompactToggleProps) {
    return (
        <Tooltip title={<FormattedMessage id={tooltipId} />} placement="bottom">
            <Box
                onClick={() => onChange(!value)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    cursor: 'pointer',
                }}
            >
                <Typography
                    variant="body2"
                    fontSize={11}
                    noWrap
                    color="rgba(255, 255, 255, 0.85)"
                    sx={{ userSelect: 'none' }}
                >
                    <FormattedMessage id={labelId} />
                </Typography>
                <Switch
                    checked={value}
                    onChange={(_, checked) => onChange(checked)}
                />
            </Box>
        </Tooltip>
    );
}
